import dayjs from 'dayjs';
import { t } from 'i18next';
import { convertToHTML } from '../../../../../utils/convertToHTML';

export const supervisionAnnouncementInfo = ({
  anounce,
  supervision: fullSupervision
}) => {
  const currentAnounce = anounce?.[0] || {};
  const { supervision: anounceSupervision = {}, description } = currentAnounce;

  const supervision = fullSupervision || anounceSupervision;

  const isFinished =
    supervision?.is_archived === true ||
    ['OUTDATED', 'CANCEL', 'INTERRUPT', 'ARCHIVED', 'FINISHED'].includes(
      supervision?.status
    );

  const reference = isFinished ? '-' : supervision?.reference || '-';
  const formatDate = (date) => {
    const d = dayjs(date);
    return d.isValid() ? d.format('DD/MM/YYYY') : '-';
  };

  const startDate = !isFinished
    ? formatDate(supervision?.main_informations?.start_date)
    : '-';

  const endDate = !isFinished
    ? formatDate(supervision?.main_informations?.end_date)
    : '-';

  const state = isFinished
    ? '-'
    : supervision?.petsitting_address?.address?.state || '-';

  const installation =
    supervision?.petsitting_address?.type_of_storage_for_pensioner
      ?.parking_and_installation?.installation || {};

  const formatBoolean = (value) => {
    if (value === true) return t('yes');
    if (value === false) return t('no');
    return '-';
  };

  const alarm = isFinished ? '-' : formatBoolean(installation?.alarm);
  const telesurveillance = isFinished
    ? '-'
    : formatBoolean(installation?.telesurveillance);

  return [
    {
      label: 'supervisions.show.anounce.reference',
      span: 0,
      content: reference
    },
    {
      label: 'supervisions.show.anounce.start_date',
      span: 1,
      content: startDate
    },
    {
      label: 'supervisions.show.anounce.end_date',
      span: 1,
      content: endDate
    },
    {
      label: 'supervisions.show.anounce.state',
      span: 1,
      content: state
    },
    {
      label: 'supervisions.show.anounce.alarm',
      span: 1,
      content: alarm
    },
    {
      label: 'supervisions.show.anounce.telesurveillance',
      span: 1,
      content: telesurveillance
    },
    {
      label: 'supervisions.show.anounce.description',
      span: 10,
      content:
        (description &&
          convertToHTML({
            htmlContent: description
          })) ||
        '-'
    }
  ];
};
